// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const optOutModal = "OptOutModal__optOutModal__aJ6wc";
export const buttonWrapper = "OptOutModal__buttonWrapper__3pXlp";
export const checkbox = "OptOutModal__checkbox__fGuZi";